import { Route, Routes, useLocation, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import React, { useEffect } from "react"
import routes from "../routes"
import { ToastContainer } from "react-toastify"
import {
  setCurrentValuation,
  setValuations,
} from "../../redux/valuations.slice"
import { isAuthRoute } from "../../utils/helpers";

const RootShell = () => {
  const navigate = useNavigate()
  const { valuations, currentValuation, independentAuthToken } = useSelector(
    (store) => store.valuationsDetails
  )
  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    const manageRedirects = async () => {
      if (
        window.location.pathname.includes("security-and-privacy") ||
        window.location.pathname.includes("terms-and-conditions") ||
          isAuthRoute(window.location.pathname)
      ) {
        return
      }

      if (!currentValuation || currentValuation === "undefined" || currentValuation === "null") {
        if (
          !window.location.pathname.includes("user-valuations") &&
          Object.keys(valuations ?? {}).length > 0
        ) {
          dispatch(setValuations({ valuations: {} }))
        }
        if (!independentAuthToken) {
          navigate({pathname:"/"+routes["root"].children["default"].path,search:location.search})
        } else {
          navigate({pathname:"/" + routes["root"].children["user-valuations"].path,search:location.search})
        }
      } else {
        if (valuations[currentValuation]?.authToken) {
          navigate(
            {pathname:`/valuations/${currentValuation}/${routes["main-shell"].children["home"].path}`,search:location.search}
          )
        } else {
          dispatch(setCurrentValuation(undefined))
        }
      }
    }
    manageRedirects()
  }, [navigate, valuations, currentValuation, dispatch, location.pathname])

  return (
    <div>
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={true}
        closeButton={false}
        limit={2}
      />
      <Routes>
        <Route path={routes["root"].path} element={routes["root"].element}>
          <Route
            path={routes["facebook-callback"].path}
            element={routes["facebook-callback"].element}
          />
          <Route
            path={routes["terms-and-conditions"].path}
            element={routes["terms-and-conditions"].element}
          />
          {Object.keys(routes["root"].children).map((key, index) => (
              <Route
                  key={`root-route-${index}`}
                  exact={routes["root"].children[key].exact}
                  path={routes["root"].children[key].path}
                  element={routes["root"].children[key].element}
              />
          ))}
        </Route>
      </Routes>
    </div>
  )
}

export default RootShell
